import { createApiSlice } from "@common";
import { CRUD_COMPETITOR_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addCompetitorStatus",
    method: "post",
    url: CRUD_COMPETITOR_STATUS,
    stateKey: "message",
  },
  {
    name: "getCompetitorStatus",
    method: "get",
    url: CRUD_COMPETITOR_STATUS,
    stateKey: "data",
  },
  {
    name: "updateCompetitorStatus",
    method: "put",
    url: CRUD_COMPETITOR_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteCompetitorStatus",
    method: "delete",
    url: CRUD_COMPETITOR_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"competitorStatus",
 apiConfig, 
 customReducers);
const competitorStatusSlice = slice;

export default competitorStatusSlice.reducer;

export const {
  addCompetitorStatus,
  getCompetitorStatus,
  updateCompetitorStatus,
  deleteCompetitorStatus,
} = thunks;

export const { rowSelect } = actions;
